import { HttpTypes } from '@/types';
import { IBlog, IBlogPost } from '@/types/blog';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

class BlogsPages {
  private client: AxiosInstance;
  private routePath = '/sites';

  public host = '';

  constructor(client: AxiosInstance) {
    client.interceptors.request.use();

    this.client = client;
  }

  interceptRequest(config: AxiosRequestConfig) {
    config.headers = {
      ...config.headers,
    };

    return config;
  }

  async detail(
    slug: string,
    headers?: Record<string, unknown>
  ): Promise<HttpTypes.IResponse<IBlogPost>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/blogspot/public/${slug}`, {
      headers: {
        ...headers,
        'X-Jstore-Host': this.host,
      },
    });

    return result.data;
  }

  async list(
    slug: string,
    params?: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<HttpTypes.StoreBlogPostElementListResponse[]>> {
    const result = await this.client.get(`${this.routePath}/blogs/public/${slug}`, {
      params,
      headers: {
        Origin: this.host,
      },
    });

    return result.data;
  }

  async blogCategoryList(
    queryParams: HttpTypes.FindParams,
    headers?: Record<string, unknown>
  ): Promise<HttpTypes.IResponse<IBlog[]>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/blog`, {
      params: queryParams,
      headers: {
        ...headers,
        Origin: this.host,
      },
    });

    return result.data;
  }

  async postList(
    queryParams: HttpTypes.FindParams,
    headers?: Record<string, unknown>
  ): Promise<HttpTypes.IResponse<IBlogPost[]>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/blogpost`, {
      params: queryParams,
      headers: {
        ...headers,
        'X-Jstore-Host': this.host,
        Origin: this.host,
      },
    });

    return result.data;
  }
}

export default BlogsPages;
